import { BALLOTREPORTSTYPE } from "../definitions";

const initialState = {
  ballotReportUserData: null,
  needToBallotCallAPI: false,
  error: null,
  deletedMember: null,
  ballotMemberNotUpdated: false,
  ballotMemberDelete: false,
  ballotMemberDeleteData: null,
};
const ballotReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case BALLOTREPORTSTYPE.UPDATE_BALLOT_REPORT_INITIATE: {
      return {
        ...state,
        ballotReportUserData: null,
      };
    }
    case BALLOTREPORTSTYPE.UPDATE_BALLOT_REPORT_SUCCESS: {
      return {
        ...state,
        ballotReportUserData: action.payload,
        error: null,
      };
    }
    case BALLOTREPORTSTYPE.UPDATE_BALLOT_REPORTS_STATUS: {
      return {
        ...state,
        ballotMemberUpdated: action.payload,
      };
    }
    case BALLOTREPORTSTYPE.UPDATE_BALLOT_REPORT_FAILED: {
      return {
        ...state,
        error: action.payload,
      };
    }

    case BALLOTREPORTSTYPE.NEED_TO_CALL_BALLOT_API: {
      return {
        ...state,
        needToBallotCallAPI: action.payload,
        ballotMemberDelete: false,
        ballotMemberUpdated: false,
      };
    }

    case BALLOTREPORTSTYPE.BALLOT_MEMBER_DELTED_SUCCESS: {
      return {
        ...state,
        ballotMemberDelete: action.payload.flag,
        ballotMemberDeleteData: action.payload.data,
      };
    }
    case BALLOTREPORTSTYPE.FAILD_BALLOT_DELETE_MEMBER: {
      return {
        ...state,
        ballotMemberDelete: false,
        ballotMemberDeleteData: action.payload.data,
        error: action.payload,
      };
    }
    case BALLOTREPORTSTYPE.BALLOT_API_STATUS: {
      return {
        ...state,
        ballotApiStatus: action.payload,
      };
    }

    default:
      return state;
  }
};

export { ballotReportReducer };
